var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7732 0.226756C15.4709 -0.0755854 14.9807 -0.0755854 14.6784 0.226756L8 6.90513L1.32163 0.226756C1.01929 -0.0755854 0.529097 -0.0755854 0.226756 0.226756C-0.0755854 0.529097 -0.0755854 1.01929 0.226756 1.32163L6.90513 8L0.226756 14.6784C-0.0755854 14.9807 -0.0755854 15.4709 0.226756 15.7732C0.529097 16.0756 1.01929 16.0756 1.32163 15.7732L8 9.09487L14.6784 15.7732C14.9807 16.0756 15.4709 16.0756 15.7732 15.7732C16.0756 15.4709 16.0756 14.9807 15.7732 14.6784L9.09487 8L15.7732 1.32163C16.0756 1.01929 16.0756 0.529097 15.7732 0.226756Z",
    fill: "#B9B9C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.67f934f2.svg";
export { ForwardRef as ReactComponent };